import { Link, Box } from "@chakra-ui/react";

export default function Route({
  text,
  href,
  fontWeight = "var(--panda-main-font-weight)",
  fontSize = "15px",
  color = "white",
  backgroundColor = "var(--panda-main-color)!important",
  borderRadius = "3px",
  classProp = "",
}) {
  return (
    <Link className={`flex-center`} href={href}>
      <Box
        className={classProp}
        borderRadius={borderRadius}
        color={color}
        fontSize={fontSize}
        backgroundColor={backgroundColor}
        fontWeight={fontWeight}
      >
        {text}
      </Box>
    </Link>
  );
}
